module.exports = __webpack_public_path__ + "img/goldregen-2020-031.a2ebfcec.jpg";